import type { StepEvents } from "./events";

/** Fil des événements de la station (pannes, chantiers finis, paiements), pour le rendu et l'interface. */
type Listener = (events: StepEvents) => void;

const listeners = new Set<Listener>();

export function onStationEvents(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function emitStationEvents(events: StepEvents): void {
  if (events.modules.length === 0 && events.payments.length === 0 && events.levelUp === null) return;
  for (const listener of listeners) listener(events);
}
